import { SHOW_TOAST_MESSAGE } from '../actions/common';

const DEFAULT_TOAST_TIMEOUT = 10000;

const initialState = {
  toastMessage: '',
  toastTimeOut: DEFAULT_TOAST_TIMEOUT,
};

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_TOAST_MESSAGE:
      return {
        ...state,
        toastMessage: action.message,
        toastTimeOut: action.timeOut || initialState.toastTimeOut,
      };

    default:
      return state;
  }
};

export default commonReducer;
